import React, {Fragment} from 'react';

import {Grid} from '@material-ui/core';

import {EfeSave} from 'components';
import {EfeViewsArray} from 'commons/models';
import {useViewSearch} from 'commons/utils/Functions';
import {useFlowContext} from 'context/onboarding-flow/OnboardingFlow';
import {useMenuContext} from 'context/onboarding-menu/OnboardingMenu';

function DataDocumentation() {
    const {menu} = useMenuContext();
    const {flow, moduleStep, updateModuleStep} = useFlowContext();
    const views: Array<EfeViewsArray> = useViewSearch({...flow}, [...menu]);

    return (
        <Fragment>
            <Grid container direction='row' justifyContent='space-between'>
                {views &&
                    views.length > 0 &&
                    views.map((view: EfeViewsArray) => {
                        return (
                            <Grid item xs={12} key={view.index}>
                                {view.view}
                            </Grid>
                        );
                    })}
            </Grid>
            <EfeSave
                flow={flow}
                menu={menu}
                disabled={moduleStep}
                updateModuleStep={updateModuleStep}
            />
        </Fragment>
    );
}

export default DataDocumentation;
